(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    if (customElements.get('cart-page')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));

    class CartPage extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.sectionId = this.dataset.sectionId;
        this.queue = Promise.resolve();
        this.timers = new Map();
        this.live = this.querySelector('[data-ct-live]');

        if (!reduceMotion.matches && !(window.Shopify && window.Shopify.designMode)) {
          this.classList.add('is-entering');
          setTimeout(() => this.classList.remove('is-entering'), 1400);
        }

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('change', (e) => this.onChange(e), { signal });
        this.addEventListener('keydown', (e) => this.onKeydown(e), { signal });
        this.addEventListener('input', (e) => this.onInput(e), { signal });

        this.bindBar();
        this.loadRecommendations();
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.barIO) this.barIO.disconnect();
        this.timers.forEach((t) => clearTimeout(t));
      }

      /* ---------- Events ---------- */
      onClick(e) {
        const step = e.target.closest('[data-ct-step]');
        if (step) {
          const input = step.closest('[data-ct-qty]').querySelector('[data-ct-input]');
          const inc = parseInt(input.step, 10) || 1;
          const min = parseInt(input.min, 10) || 0;
          const max = input.max ? parseInt(input.max, 10) : Infinity;
          const cur = parseInt(input.value, 10) || 0;
          const next = Math.min(Math.max(cur + inc * parseInt(step.dataset.ctStep, 10), min), max);
          if (next === cur) return;
          input.value = next;
          this.bump(input);
          this.schedule(input, 380);
          return;
        }

        const remove = e.target.closest('[data-ct-remove]');
        if (remove) {
          e.preventDefault();
          this.change(remove.dataset.ctRemove, 0);
          return;
        }

        const add = e.target.closest('[data-ct-add]');
        if (add) {
          e.preventDefault();
          this.add(add);
        }
      }

      onChange(e) {
        if (e.target.matches('[data-ct-input]')) this.schedule(e.target, 0);
        if (e.target.matches('[data-ct-note]')) this.saveNote(e.target.value);
      }

      onInput(e) {
        if (e.target.matches('[data-ct-note]')) {
          clearTimeout(this.noteTimer);
          const value = e.target.value;
          this.noteTimer = setTimeout(() => this.saveNote(value), 700);
        }
      }

      onKeydown(e) {
        // Enter in a quantity field updates the line instead of submitting to checkout.
        if (e.key === 'Enter' && e.target.matches('[data-ct-input]')) {
          e.preventDefault();
          this.schedule(e.target, 0);
        }
      }

      bump(input) {
        if (reduceMotion.matches) return;
        input.classList.remove('is-bump');
        void input.offsetWidth;
        input.classList.add('is-bump');
      }

      schedule(input, delay) {
        const key = input.dataset.ctKey;
        clearTimeout(this.timers.get(key));
        this.timers.set(
          key,
          setTimeout(() => {
            this.timers.delete(key);
            let qty = parseInt(input.value, 10);
            if (Number.isNaN(qty) || qty < 0) qty = parseInt(input.dataset.ctValue, 10) || 0;
            if (String(qty) === input.dataset.ctValue) return;
            this.change(key, qty);
          }, delay)
        );
      }

      /* ---------- Cart API ---------- */
      change(key, quantity) {
        this.queue = this.queue.then(() => this.runChange(key, quantity)).catch(() => {});
        return this.queue;
      }

      async runChange(key, quantity) {
        const item = this.querySelector(`[data-ct-item="${CSS.escape(key)}"]`);
        const error = item && item.querySelector('[data-ct-error]');
        if (error) error.textContent = '';
        this.setBusy(true, item);

        try {
          const res = await fetch(`${this.dataset.changeUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: key,
              quantity,
              sections: [this.sectionId],
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();

          if (!res.ok || data.status) {
            const msg = data.description || data.message || 'Something went wrong. Please try again.';
            this.showLineError(item, msg);
            return;
          }

          if (quantity === 0 && item && !reduceMotion.matches) {
            item.classList.add('is-leaving');
            await wait(300);
          }

          this.render(data.sections && data.sections[this.sectionId]);
          this.announce(quantity === 0 ? 'Item removed from your bag.' : 'Your bag has been updated.');

          // Quantity capped by stock: tell the shopper on that line.
          if (quantity > 0) {
            const line = data.items && data.items.find((i) => i.key === key);
            if (line && line.quantity < quantity) {
              const fresh = this.querySelector(`[data-ct-item="${CSS.escape(key)}"] [data-ct-error]`);
              if (fresh) fresh.textContent = `Only ${line.quantity} available — we've updated your bag.`;
            }
          }

          this.emit(data);
        } catch (err) {
          this.showLineError(item, 'Connection problem. Please try again.');
        } finally {
          this.setBusy(false);
        }
      }

      showLineError(item, msg) {
        if (item) {
          const input = item.querySelector('[data-ct-input]');
          if (input) input.value = input.dataset.ctValue;
          const error = item.querySelector('[data-ct-error]');
          if (error) error.textContent = msg;
        } else {
          const general = this.querySelector('[data-ct-general-error]');
          if (general) {
            general.textContent = msg;
            general.hidden = false;
          }
        }
        this.announce(msg);
      }

      setBusy(busy, item) {
        this.classList.toggle('is-busy', busy);
        this.setAttribute('aria-busy', String(busy));
        if (item) item.classList.toggle('is-busy', busy);
        if (!busy) this.querySelectorAll('.ct-item.is-busy').forEach((el) => el.classList.remove('is-busy'));
      }

      async saveNote(note) {
        try {
          await fetch(`${this.dataset.updateUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note }),
          });
        } catch (e) {
          /* The note is still sent with the form on checkout. */
        }
      }

      async add(button) {
        button.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.ctAdd), quantity: 1 }],
              sections: [this.sectionId],
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (!res.ok || data.status) {
            this.showLineError(null, data.description || data.message || 'Could not add this item.');
            button.removeAttribute('aria-busy');
            return;
          }
          const pick = button.closest('.ct-pick');
          if (pick && !reduceMotion.matches) {
            pick.style.transition = 'opacity .3s ease, transform .4s cubic-bezier(.22,1,.36,1)';
            pick.style.opacity = '0';
            pick.style.transform = 'translate3d(0,-10px,0)';
          }
          this.render(data.sections && data.sections[this.sectionId]);
          this.announce('Added to your bag.');
          const cart = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }).then(
            (r) => r.json()
          );
          this.emit(cart);
          if (pick) pick.remove();
          this.pruneRecs();
        } catch (e) {
          button.removeAttribute('aria-busy');
          this.showLineError(null, 'Connection problem. Please try again.');
        }
      }

      emit(cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'cart-page' } }));
      }

      announce(msg) {
        if (!this.live) return;
        this.live.textContent = '';
        setTimeout(() => (this.live.textContent = msg), 60);
      }

      /* ---------- Render (Section Rendering API) ---------- */
      render(html) {
        if (!html) {
          window.location.reload();
          return;
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-ct-body]');
        const body = this.querySelector('[data-ct-body]');
        if (!next || !body) return;

        const active = document.activeElement;
        const focusId = active && this.contains(active) ? active.dataset.ctFocus : null;
        const hadFocus = active && this.contains(active);
        const oldFill = body.querySelector('[data-ct-ship-fill]');
        const oldP = oldFill ? getComputedStyle(oldFill).getPropertyValue('--p') : null;
        const oldTotal = (body.querySelector('.ct-total__value') || {}).textContent;

        body.replaceWith(next);

        // Free shipping line grows from where it was.
        const fill = next.querySelector('[data-ct-ship-fill]');
        if (fill && oldP !== null && !reduceMotion.matches) {
          const target = fill.style.getPropertyValue('--p');
          fill.style.transition = 'none';
          fill.style.setProperty('--p', oldP);
          void fill.offsetWidth;
          fill.style.transition = '';
          requestAnimationFrame(() => fill.style.setProperty('--p', target));
        }

        const total = next.querySelector('[data-ct-total]');
        if (total && oldTotal !== undefined && total.textContent.indexOf(oldTotal.trim()) === -1)
          total.classList.add('is-fresh');

        if (hadFocus) {
          const target =
            (focusId && next.querySelector(`[data-ct-focus="${CSS.escape(focusId)}"]`)) ||
            next.querySelector('[data-ct-title]');
          if (target) target.focus({ preventScroll: true });
        }

        if (!next.querySelector('.ct-item')) {
          const recs = this.querySelector('[data-ct-recs]');
          if (recs) recs.innerHTML = '';
        }

        this.bindBar();
      }

      pruneRecs() {
        const recs = this.querySelector('[data-ct-recs-source]');
        if (recs && !recs.querySelector('.ct-pick')) recs.remove();
      }

      /* ---------- Mobile checkout bar ---------- */
      bindBar() {
        if (this.barIO) this.barIO.disconnect();
        const bar = this.querySelector('[data-ct-bar]');
        const receipt = this.querySelector('[data-ct-checkout]');
        const items = this.querySelector('.ct-items');
        if (!bar || !receipt || !('IntersectionObserver' in window)) return;
        const btn = bar.querySelector('button');
        let receiptSeen = false;
        let itemsSeen = false;
        const set = () => {
          const show = itemsSeen && !receiptSeen;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', String(!show));
          if (btn) btn.tabIndex = show ? 0 : -1;
        };
        this.barIO = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === receipt) receiptSeen = entry.isIntersecting;
            else itemsSeen = entry.isIntersecting;
          });
          set();
        });
        this.barIO.observe(receipt);
        if (items) this.barIO.observe(items);
      }

      /* ---------- Recommendations ---------- */
      async loadRecommendations() {
        const pid = this.dataset.recsProduct;
        const slot = this.querySelector('[data-ct-recs]');
        if (!pid || !slot || slot.children.length || !this.dataset.recsUrl) return;

        const load = async () => {
          try {
            const url = `${this.dataset.recsUrl}?section_id=${encodeURIComponent(
              this.sectionId
            )}&product_id=${encodeURIComponent(pid)}&limit=6&intent=related`;
            const html = await fetch(url).then((r) => (r.ok ? r.text() : ''));
            if (!html) return;
            const src = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ct-recs-source]');
            if (!src) return;
            const picks = src.querySelectorAll('.ct-pick');
            picks.forEach((p, i) => {
              if (i >= 4) p.remove();
            });
            slot.replaceChildren(src);
          } catch (e) {
            /* Recommendations are optional. */
          }
        };

        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              io.disconnect();
              load();
            },
            { rootMargin: '400px 0px' }
          );
          io.observe(slot);
        } else {
          load();
        }
      }
    }

    customElements.define('cart-page', CartPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-fits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('what-fits')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const FILL = 0.8; // soft bags never pack perfectly
    const EPS = 0.05; // mm
    const TILT = [-2.4, 1.7, -1.1, 2.6, -1.9, 1.2, -0.8, 2.1];
    const WORD = ['wide', 'tall', 'thick'];
    const tf = (x, y, sc, r) => `translate(${x}px, ${y}px) scale(${sc}) rotate(${r}deg)`;

    class WhatFits extends HTMLElement {
      connectedCallback() {
        this.inside = this.querySelector('[data-wf-inside]');
        if (!this.inside) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.timers = [];
        this.W = parseFloat(this.dataset.w);
        this.H = parseFloat(this.dataset.h);
        this.D = parseFloat(this.dataset.d);
        this.cap = this.W * this.H * this.D * FILL;
        this.used = 0;
        this.packed = new Map();
        this.chips = Array.from(this.querySelectorAll('[data-wf-item]'));
        this.note = this.querySelector('[data-wf-note]');
        this.emptyText = this.dataset.empty || '';

        let unit = this.dataset.unit;
        try {
          const saved = window.localStorage.getItem('wf-unit');
          if (saved === 'cm' || saved === 'in') unit = saved;
        } catch (err) {
          /* storage can be blocked; the section still works */
        }
        this.classList.add('is-js');
        this.setUnit(unit, false);
        this.update();

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        document.addEventListener('shopify:block:select', (e) => this.onBlockSelect(e), { signal });

        this.prepack();
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.io) this.io.disconnect();
        (this.timers || []).forEach((t) => clearTimeout(t));
      }

      /* ---------- events ---------- */

      onClick(e) {
        const chip = e.target.closest('[data-wf-item]');
        if (chip) {
          if (this.packed.has(chip.dataset.id)) this.takeOut(chip, true);
          else this.pack(chip, true, false);
          return;
        }
        const thing = e.target.closest('.wf-thing');
        if (thing && !thing.classList.contains('is-ghost') && !thing.classList.contains('is-leaving')) {
          const c = this.chips.find((x) => x.dataset.id === thing.dataset.id);
          if (c) this.takeOut(c, true);
          return;
        }
        const u = e.target.closest('[data-wf-unit]');
        if (u) {
          this.setUnit(u.dataset.wfUnit, true);
          return;
        }
        if (e.target.closest('[data-wf-empty]')) this.emptyAll();
      }

      onBlockSelect(e) {
        const chip = this.chips.find((c) => c.dataset.id === (e.detail && e.detail.blockId));
        if (!chip) return;
        chip.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        chip.classList.remove('is-flash');
        void chip.offsetWidth;
        chip.classList.add('is-flash');
      }

      /* ---------- measuring ---------- */

      fmt(mm) {
        const v = this.unit === 'in' ? mm / 25.4 : mm / 10;
        return String(Math.round(v * 10) / 10);
      }

      /* Try every way of turning the thing; keep the drawn face forward when possible. */
      orient(w, h, d) {
        const ways = [
          [w, h, d, 'up'],
          [h, w, d, 'rot'],
          [w, d, h, 'side'],
          [d, w, h, 'side'],
          [h, d, w, 'side'],
          [d, h, w, 'side'],
        ];
        const bag = [this.W, this.H, this.D];
        let best = null;
        let near = null;
        ways.forEach(([fw, fh, fd, kind]) => {
          const over = [fw - bag[0], fh - bag[1], fd - bag[2]];
          const worst = Math.max(...over);
          const way = { fw, fh, fd, kind, over: worst, dim: over.indexOf(worst) };
          if (worst <= EPS) {
            if (!best) best = way;
            else if (best.kind === 'side' && kind === 'side' && fw * fh > best.fw * best.fh) best = way;
          } else if (!near || worst < near.over - EPS) {
            near = way;
          }
        });
        return best ? Object.assign(best, { ok: true }) : Object.assign(near, { ok: false });
      }

      /* Stand the thing on the bottom where it hides the least of what's already in. */
      slot(fw, fh) {
        const max = Math.max(0, this.W - fw);
        const spots = new Set([0, max]);
        this.packed.forEach((p) => {
          spots.add(p.x + p.fw);
          spots.add(p.x - fw);
        });
        let best = 0;
        let bestScore = Infinity;
        Array.from(spots)
          .map((x) => Math.min(max, Math.max(0, x)))
          .sort((a, b) => a - b)
          .forEach((x) => {
            let score = 0;
            this.packed.forEach((p) => {
              const ov = Math.min(x + fw, p.x + p.fw) - Math.max(x, p.x);
              if (ov > 0) score += ov * Math.min(fh, p.fh);
            });
            if (score < bestScore - 0.01) {
              bestScore = score;
              best = x;
            }
          });
        return best;
      }

      /* ---------- drawing ---------- */

      makeThing(chip, way, x) {
        const w = parseFloat(chip.dataset.w);
        const h = parseFloat(chip.dataset.h);
        const el = document.createElement('div');
        el.className = 'wf-thing';
        el.dataset.id = chip.dataset.id;
        el.style.left = `${(x / this.W) * 100}%`;
        el.style.width = `${(way.fw / this.W) * 100}%`;
        el.style.height = `${(way.fh / this.H) * 100}%`;
        // Smaller things sit in front so nothing small disappears behind a laptop.
        el.style.zIndex = String(Math.max(1, 1000000 - Math.round((way.fw * way.fh) / 10)));

        const art = document.createElement('span');
        art.className = 'wf-thing__art';
        if (way.kind === 'side') {
          art.classList.add('wf-thing__box');
        } else {
          const src = chip.querySelector('.wf-art');
          if (src) {
            const copy = src.cloneNode(true);
            if (copy.tagName === 'IMG') copy.loading = 'eager';
            art.appendChild(copy);
          }
          if (way.kind === 'rot') {
            el.classList.add('is-rot');
            art.style.setProperty('--aw', `${(w / way.fw) * 100}%`);
            art.style.setProperty('--ah', `${(h / way.fh) * 100}%`);
          }
        }
        el.appendChild(art);
        return el;
      }

      tiltFor(chip, way) {
        const i = Math.max(0, this.chips.indexOf(chip));
        return TILT[i % TILT.length] * Math.min(1, 90 / Math.max(way.fw, way.fh));
      }

      /* ---------- packing ---------- */

      pack(chip, animate, quiet) {
        const id = chip.dataset.id;
        if (this.packed.has(id)) return true;
        const name = chip.dataset.name;
        const w = parseFloat(chip.dataset.w);
        const h = parseFloat(chip.dataset.h);
        const d = parseFloat(chip.dataset.d);
        const way = this.orient(w, h, d);

        if (!way.ok) {
          if (!quiet) this.nope(chip, way);
          return false;
        }
        const vol = w * h * d;
        if (this.used + vol > this.cap + 1) {
          if (!quiet) {
            this.shake(chip);
            const meter = this.querySelector('.wf-meter');
            if (meter && !reduceMotion.matches) {
              meter.classList.remove('is-pulse');
              void meter.offsetWidth;
              meter.classList.add('is-pulse');
            }
            this.say(`${name}: no room left. Take something out first.`, true);
          }
          return false;
        }

        const x = this.slot(way.fw, way.fh);
        const el = this.makeThing(chip, way, x);
        const tilt = this.tiltFor(chip, way);
        el.style.setProperty('--r', `${tilt.toFixed(2)}deg`);
        this.inside.appendChild(el);

        this.packed.set(id, { el, vol, x, fw: way.fw, fh: way.fh, tilt });
        this.used += vol;
        chip.setAttribute('aria-pressed', 'true');
        chip.classList.remove('is-nofit');
        this.update();
        if (!quiet) this.say(`${name} is in.`, false);
        if (animate && !reduceMotion.matches && el.animate) this.fly(el, chip, tilt);
        return true;
      }

      fly(el, chip, tilt) {
        const from = (chip.querySelector('.wf-chip__art') || chip).getBoundingClientRect();
        const to = el.getBoundingClientRect();
        const box = this.inside.getBoundingClientRect();
        if (!to.width || !to.height) return;
        const sc = Math.max(0.04, Math.min(from.width / to.width, from.height / to.height));
        const dx = from.left + from.width / 2 - (to.left + to.width / 2);
        const dy = from.top + from.height / 2 - (to.top + to.height / 2);
        const lift = -(box.height + 10);
        el.animate(
          [
            { transform: tf(dx, dy, sc, 0), opacity: 0, easing: 'cubic-bezier(0.25, 0.7, 0.35, 1)' },
            { offset: 0.12, opacity: 1 },
            { offset: 0.55, transform: tf(0, lift, 1, tilt * 3), easing: 'cubic-bezier(0.55, 0, 0.85, 0.4)' },
            { offset: 0.82, transform: tf(0, 3, 1, tilt * 0.5), easing: 'cubic-bezier(0.3, 0.8, 0.4, 1)' },
            { transform: tf(0, 0, 1, tilt), opacity: 1 },
          ],
          { duration: 820, fill: 'backwards' }
        );
      }

      takeOut(chip, animate) {
        const id = chip.dataset.id;
        const item = this.packed.get(id);
        if (!item) return;
        this.packed.delete(id);
        this.used = Math.max(0, this.used - item.vol);
        if (this.packed.size === 0) this.used = 0;
        chip.setAttribute('aria-pressed', 'false');
        this.update();
        if (animate) this.say(`${chip.dataset.name} is out.`, false);
        this.lift(item, animate);
      }

      lift(item, animate) {
        const el = item.el;
        el.classList.add('is-leaving');
        if (!animate || reduceMotion.matches || !el.animate) {
          el.remove();
          return;
        }
        const up = -(this.inside.getBoundingClientRect().height * 0.55);
        const a = el.animate(
          [
            { transform: tf(0, 0, 1, item.tilt), opacity: 1 },
            { transform: tf(0, up, 0.96, -item.tilt), opacity: 0 },
          ],
          { duration: 420, easing: 'cubic-bezier(0.4, 0, 0.8, 0.4)', fill: 'forwards' }
        );
        a.onfinish = () => el.remove();
        a.oncancel = () => el.remove();
      }

      emptyAll() {
        let i = 0;
        this.chips.forEach((chip) => {
          const item = this.packed.get(chip.dataset.id);
          if (!item) return;
          this.packed.delete(chip.dataset.id);
          chip.setAttribute('aria-pressed', 'false');
          const delay = reduceMotion.matches ? 0 : i * 60;
          i += 1;
          if (delay) this.timers.push(setTimeout(() => this.lift(item, true), delay));
          else this.lift(item, true);
        });
        this.used = 0;
        this.update();
        this.say('The bag is empty.', false);
        const first = this.chips[0];
        if (first) first.focus({ preventScroll: true });
      }

      /* Too big: the thing appears to scale at the bag, shows by how much, and backs off. */
      nope(chip, way) {
        chip.classList.add('is-nofit');
        this.shake(chip);
        if (this.ghost) this.ghost.remove();
        const x = (this.W - way.fw) / 2;
        const g = this.makeThing(chip, way, x);
        g.classList.add('is-ghost');
        const tag = document.createElement('span');
        tag.className = 'wf-thing__tag';
        const amount = `${this.fmt(way.over)} ${this.unit} too ${WORD[way.dim]}`;
        tag.textContent = amount;
        g.appendChild(tag);
        this.inside.appendChild(g);
        this.ghost = g;

        const done = () => {
          g.remove();
          if (this.ghost === g) this.ghost = null;
        };
        const frames = reduceMotion.matches
          ? [{ opacity: 0 }, { offset: 0.08, opacity: 1 }, { offset: 0.88, opacity: 1 }, { opacity: 0 }]
          : [
              { transform: 'translate(0px, -40px)', opacity: 0, easing: 'cubic-bezier(0.3, 0.8, 0.4, 1)' },
              { offset: 0.16, transform: 'translate(0px, 0px)', opacity: 1 },
              { offset: 0.28, transform: 'translate(-5px, 0px)' },
              { offset: 0.38, transform: 'translate(4px, 0px)' },
              { offset: 0.48, transform: 'translate(-2px, 0px)' },
              { offset: 0.56, transform: 'translate(0px, 0px)' },
              { offset: 0.86, transform: 'translate(0px, 0px)', opacity: 1, easing: 'cubic-bezier(0.4, 0, 0.8, 0.4)' },
              { transform: 'translate(0px, -28px)', opacity: 0 },
            ];
        if (g.animate) {
          const a = g.animate(frames, { duration: 2000, fill: 'forwards' });
          a.onfinish = done;
          a.oncancel = done;
        } else {
          this.timers.push(setTimeout(done, 2000));
        }
        this.say(`${chip.dataset.name} won’t fit: it’s ${amount}.`, true);
      }

      shake(chip) {
        if (reduceMotion.matches) return;
        chip.classList.remove('is-shake');
        void chip.offsetWidth;
        chip.classList.add('is-shake');
      }

      /* ---------- read-outs ---------- */

      update() {
        const n = this.packed.size;
        const ratio = this.cap > 0 ? Math.min(1, this.used / this.cap) : 0;
        const pct = n ? Math.max(1, Math.round(ratio * 100)) : 0;
        const meter = this.querySelector('[data-wf-meter]');
        if (meter) meter.style.transform = `scaleX(${ratio})`;
        const count = this.querySelector('[data-wf-count]');
        if (count) count.textContent = n ? `${n} ${n === 1 ? 'thing' : 'things'} packed` : this.emptyText;
        const pctEl = this.querySelector('[data-wf-pct]');
        if (pctEl) pctEl.textContent = `${pct}% full`;
        const empty = this.querySelector('[data-wf-empty]');
        if (empty) empty.hidden = n === 0;
        this.classList.toggle('is-full', pct >= 95);
      }

      say(msg, bad) {
        if (!this.note) return;
        this.note.classList.toggle('is-bad', !!bad);
        // Clear first so the same sentence is announced again.
        this.note.textContent = '';
        window.requestAnimationFrame(() => {
          this.note.textContent = msg;
        });
      }

      setUnit(u, save) {
        this.unit = u === 'in' ? 'in' : 'cm';
        this.querySelectorAll('[data-wf-unit]').forEach((b) =>
          b.setAttribute('aria-pressed', String(b.dataset.wfUnit === this.unit))
        );
        this.chips.forEach((c) => {
          const out = c.querySelector('[data-wf-size]');
          if (out)
            out.textContent = `${this.fmt(parseFloat(c.dataset.w))} × ${this.fmt(parseFloat(c.dataset.h))} ${
              this.unit
            }`;
        });
        const size = this.querySelector('[data-wf-bagsize]');
        if (size) size.textContent = `${this.fmt(this.W)} × ${this.fmt(this.H)} × ${this.fmt(this.D)} ${this.unit}`;
        const dw = this.querySelector('[data-wf-dim="w"]');
        if (dw) dw.textContent = `${this.fmt(this.W)} ${this.unit}`;
        const dh = this.querySelector('[data-wf-dim="h"]');
        if (dh) dh.textContent = `${this.fmt(this.H)} ${this.unit}`;
        const key = this.querySelector('[data-wf-grid]');
        if (key) key.textContent = this.unit === 'in' ? '2 in' : '5 cm';
        this.grid(this.unit === 'in' ? 50.8 : 50);
        if (save) {
          try {
            window.localStorage.setItem('wf-unit', this.unit);
          } catch (err) {
            /* ignore */
          }
        }
      }

      /* Keep the mat's lines starting exactly at the bag's bottom-left corner. */
      grid(g) {
        const stage = this.querySelector('.wf-stage');
        if (!stage) return;
        const cs = getComputedStyle(stage);
        const ml = parseFloat(cs.getPropertyValue('--ml'));
        const t = parseFloat(cs.getPropertyValue('--t'));
        const vw = parseFloat(cs.getPropertyValue('--vw'));
        const vh = parseFloat(cs.getPropertyValue('--vh'));
        if (!ml || !vw) return;
        const mx = ml - Math.ceil(ml / g) * g;
        const my = t + this.H - Math.ceil((t + this.H) / g) * g;
        this.style.setProperty('--g', String(g));
        this.style.setProperty('--mx', mx.toFixed(2));
        this.style.setProperty('--my', my.toFixed(2));
        this.style.setProperty('--mw', (vw - mx + g).toFixed(2));
        this.style.setProperty('--mh', (vh - my + g).toFixed(2));
      }

      /* Things the merchant marked as already packed drop in when the bag comes into view. */
      prepack() {
        const pre = this.chips.filter((c) => c.hasAttribute('data-packed'));
        if (!pre.length) return;
        const run = (animate) => {
          pre.forEach((chip, i) => {
            if (!animate) {
              this.pack(chip, false, true);
              return;
            }
            this.timers.push(
              setTimeout(() => {
                if (this.isConnected) this.pack(chip, true, true);
              }, 200 + i * 200)
            );
          });
        };
        if (reduceMotion.matches || !('IntersectionObserver' in window)) {
          run(false);
          return;
        }
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.io.disconnect();
            run(true);
          },
          { threshold: 0.35 }
        );
        this.io.observe(this.querySelector('.wf-stage'));
      }
    }

    customElements.define('what-fits', WhatFits);
  })();

  } catch(e) { console.error(e); }
})();
})();
